import { connect } from 'react-redux';
import { toggleScreens } from '../actions';
import ScreenPageStep from '../components/ScreenPageStep';
import { getScreenPageStep } from '../selectors';

const mapStateToProps = state => getScreenPageStep(state);

const mapDispatchToProps = dispatch => ({
    toggleScreens: (...args) => {
        dispatch(toggleScreens(...args));
    },
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ScreenPageStep);
